import { defineMessages } from "react-intl";

export const messages = defineMessages({
  sectionStoreDetailsTitle: {
    id: "TihW9+",
    defaultMessage: "Store details",
    description: "section title",
  },
  sectionStoreDetailsDescription: {
    id: "Owgj18",
    defaultMessage:
      "Your store's public name and description, used across the storefront and in SEO metadata.",
    description: "section description",
  },
  sectionCompanyTitle: {
    id: "rPX1f2",
    defaultMessage: "Company Information",
    description: "section title",
  },
  sectionCompanyDescription: {
    id: "pRYGUR",
    defaultMessage:
      "This address will be used to generate invoices and calculate shipping rates. Email address you provide here will be used as a contact address for your customers.",
    description: "section description",
  },
  sectionCustomerAccountsTitle: {
    id: "bKlRVC",
    defaultMessage: "Customer accounts",
    description: "section title for customer login and registration settings",
  },
  sectionCustomerAccountsDescription: {
    id: "jpyNZL",
    defaultMessage: "Control how customers register and sign in to your storefront.",
    description: "section description for customer accounts",
  },
  sectionEmailConfirmationTitle: {
    id: "qNeXG1",
    defaultMessage: "User registration",
    description: "User registration",
  },
  sectionEmailConfirmationHeader: {
    id: "kpRxSA",
    defaultMessage: "Require email confirmation link",
    description: "Require email confirmation link",
  },
  sectionEmailConfirmationOption: {
    id: "uRfta0",
    defaultMessage: "Enable email confirmation",
    description: "Enable email confirmation",
  },
  sectionEmailConfirmationDescription: {
    id: "/xJSe8",
    defaultMessage:
      "When users confirm their email account, all previous anonymous orders placed under the same email would be added to their order history.",
    description:
      "When users confirm their email account, all previous anonymous orders placed under the same email would be added to their order history.",
  },
  sectionApiAccessTitle: {
    id: "GNX9HV",
    defaultMessage: "API access",
    description: "section title for GraphQL API access settings",
  },
  sectionApiAccessDescription: {
    id: "NDnOZ0",
    defaultMessage: "Control which clients are allowed to call the GraphQL API directly.",
    description: "section description for API access",
  },
  sectionStorefrontTrafficTitle: {
    id: "v286+q",
    defaultMessage: "Allow storefront traffic",
    description: "card header and checkbox label",
  },
  sectionStorefrontTrafficDescription: {
    id: "vqSGtP",
    defaultMessage:
      "When enabled, anonymous clients and signed-in customers can call the GraphQL API directly. When disabled, only apps and staff users can — every other request is rejected with HTTP 401. <a>Learn more</a>.",
    description: "section description",
  },
  sectionStorefrontTrafficWarningIntro: {
    id: "9ZJLIE",
    defaultMessage: "Turning this off blocks storefronts from reaching the API on their own:",
    description: "intro to list of consequences of blocking storefront traffic",
  },
  sectionStorefrontTrafficWarningLogin: {
    id: "VvqEe2",
    defaultMessage:
      "Customer login, password reset and account confirmation stop working — the check runs before the operation is read, so authentication mutations are rejected too.",
    description: "consequence of blocking storefront traffic",
  },
  sectionStorefrontTrafficWarningAnonymous: {
    id: "ONl3Bh",
    defaultMessage: "Anonymous browsing and guest checkout are no longer possible.",
    description: "consequence of blocking storefront traffic",
  },
  sectionStorefrontTrafficWarningIntrospection: {
    id: "TL6F/t",
    defaultMessage: "Schema introspection requires app or staff credentials.",
    description: "consequence of blocking storefront traffic",
  },
  sectionStorefrontTrafficWarningCache: {
    id: "7BQ5zc",
    defaultMessage: "The setting is cached — a change takes up to 5 minutes to reach every worker.",
    description: "consequence of blocking storefront traffic",
  },
  sectionAdvancedTitle: {
    id: "BgEWXq",
    defaultMessage: "Advanced",
    description: "section title for legacy and developer store settings",
  },
  sectionAdvancedDescription: {
    id: "OP3Fgn",
    defaultMessage:
      "Legacy API options that may change in future Saleor versions. Prefer defaults unless you know you need these.",
    description: "section description for advanced store settings",
  },
  sectionWebhookEmissionTitle: {
    id: "R8+DNv",
    defaultMessage: "Webhook emission",
    description: "section title",
  },
  sectionWebhookEmissionDescription: {
    id: "GK6pQa",
    defaultMessage:
      "When enabled, update webhooks (e.g. customerUpdated) are sent even when only metadata changes. When disabled, only metadata-specific webhooks are sent. This legacy behavior will be removed in a future version.",
    description: "section description",
  },
  sectionWebhookEmissionHeader: {
    id: "0g0LHg",
    defaultMessage: "Emit update webhooks for metadata changes",
    description: "card header and checkbox label",
  },
  sectionAddressValidationTitle: {
    id: "6vf8AS",
    defaultMessage: "Address Validation",
    description: "section title",
  },
  sectionAddressValidationDescription: {
    id: "PJGv35",
    defaultMessage:
      "Controls how address fields that are not part of a country's standard format are handled. By default, such fields are removed during validation — enabling this setting preserves them as entered.",
    description: "section description",
  },
  sectionAddressValidationHeader: {
    id: "4k38A6",
    defaultMessage: "Preserve non-standard address fields",
    description: "card header and checkbox label",
  },
  sectionPasswordLoginTitle: {
    id: "kny5j9",
    defaultMessage: "Password Login",
    description: "section title",
  },
  sectionPasswordLoginDescription: {
    id: "/2o5cH",
    defaultMessage:
      "Controls whether users can authenticate using password-based login. You can allow it for everyone, restrict it to customers only, or disable it entirely.",
    description: "section description",
  },
  sectionStockAvailabilityTitle: {
    id: "v5yLSE",
    defaultMessage: "Stock availability",
    description: "section title",
  },
  sectionStockAvailabilityDescription: {
    id: "qeAmFa",
    defaultMessage:
      "When enabled, stock availability is filtered by shipping zones and the destination address (legacy behavior). When disabled, it is determined only by the direct warehouse-channel link. <a>Learn more</a>.",
    description: "section description",
  },
  sectionStockAvailabilityHeader: {
    id: "6ZnMfQ",
    defaultMessage: "Use legacy shipping zone stock availability",
    description: "card header and checkbox label",
  },
  sectionStockAvailabilityWebhooksIntro: {
    id: "wmybDi",
    defaultMessage: "When disabled, the following channel-scoped stock webhooks become available:",
    description: "intro to webhook list",
  },
});
